<template>
  <div class="learn-block">
    <div class="container">
      <img src="./images/Book-image.png">
      <h3>New to TRUE WORLD?</h3>
      <h2>Learn & Earn</h2>
      <p>This is your <span>guide</span> to understanding <span>how everything works</span> —<br> from <span>playing and winning</span> to <span>owning and trading digital assets</span>.</p>

      <div class="buttons">
        <a href="https://wiki.true.world/ ">
          <span>wiki.true.world</span>
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g opacity="0.4">
              <path d="M1.13128 11.6313C0.789573 11.973 0.789573 12.527 1.13128 12.8687C1.47299 13.2104 2.02701 13.2104 2.36872 12.8687L1.13128 11.6313ZM13.125 1.75C13.125 1.26675 12.7332 0.875 12.25 0.875L4.375 0.874999C3.89175 0.875 3.5 1.26675 3.5 1.75C3.5 2.23325 3.89175 2.625 4.375 2.625L11.375 2.625L11.375 9.625C11.375 10.1082 11.7668 10.5 12.25 10.5C12.7332 10.5 13.125 10.1082 13.125 9.625L13.125 1.75ZM2.36872 12.8687L12.8687 2.36872L11.6313 1.13128L1.13128 11.6313L2.36872 12.8687Z" fill="white"/>
            </g>
          </svg>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'learn-block',
}
</script>

<style lang="less" scoped>
  .learn-block {
    background-image: url("./images/bg-learn.png");
    background-repeat: no-repeat;
    background-position: top center;
    padding-top: 0;
    margin-top: 0;
    margin-bottom: 0px;
    min-height: 500px;

    > .container {
      background-image: linear-gradient(180deg, rgba(201, 216, 255, 0.1) 0%, rgba(201, 216, 255, 0) 100%);
      position: relative;
      min-height: 500px;
      padding-top: 96px;
      border-radius: 40px 40px 0 0;
      > img {
        position: absolute;
        top: -55px;
        left: 186px;
        width: 250px;
        height: 180px;
      }
      > h3 {
        font-family: 'Poppins';
        font-style: normal;
        font-weight: 500;
        font-size: 30px;
        line-height: 45px;
        text-align: center;
        margin-bottom: 2px;
        background: linear-gradient(90.62deg, #DF60FF 0%, #9C94FF 49.03%, #44E9C3 62.94%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        text-fill-color: transparent;
      }
      > h2 {
        color: #FFF;
        font-family: Poppins;
        font-weight: 700;
        font-size: 50px;
        line-height: 64px;
        text-align: center;
        margin-bottom: 16px;
      }
      > p {
        color: #FFFFFF99;
        font-family: Poppins;
        font-weight: 500;
        font-size: 24px;
        line-height: 38px;
        text-align: center;
        margin-bottom: 50px;
        > span {
          color: #FFF;
        }
      }
      > .buttons {
        display: flex;
        gap: 10px;
        justify-content: center;
        align-items: center;
        > a {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 8px;
          width: 190px;
          height: 60px;
          border-radius: 14px;
          transition: all .2s;
          color: #fff;
          font-size: 16px;
          line-height: 24px;
          border: 1px solid hsla(0, 0%, 100%, .2);
          &:hover {
            border-color: #fff;
          }
        }
      }
    }
  }

  @media screen and (max-width: 1439px) {
    .learn-block {
      background-size: 846px;
      padding-top: 0;
      margin-top: 45px;
      margin-bottom: 0;
      min-height: 400px;

      > .container {
        background-image: linear-gradient(180deg, rgba(201, 216, 255, 0.1) 0%, rgba(201, 216, 255, 0) 100%);
        position: relative;
        min-height: 400px;
        padding-top: 66px;
        border-radius: 30px 30px 0 0;
        > img {
          position: absolute;
          top: -55px;
          left: 76px;
          width: 198px;
          height: 143px;
        }
        > h3 {
          font-size: 24px;
          line-height: 32px;
          margin-bottom: 0px;
        }
        > h2 {
          font-size: 36px;
          line-height: 50px;
          margin-bottom: 12px;
        }
        > p {
          font-size: 18px;
          line-height: 28px;
          margin-bottom: 40px;
        }
        > .buttons {
          > a {
            width: 220px;
            height: 50px;
            border-radius: 12px;
            font-size: 14px;
            line-height: 18px;
          }
        }
      }
    }
  }
  @media screen and (max-width: 1023px) {
    .learn-block {
      background-size: 668px 540px;
      padding-top: 0;
      margin-top: 45px;
      margin-bottom: 0;
      min-height: 373px;

      > .container {
        background-image: linear-gradient(180deg, rgba(201, 216, 255, 0.1) 0%, rgba(201, 216, 255, 0) 100%);
        position: relative;
        min-height: 373px;
        padding-top: 56px;
        border-radius: 20px 20px 0 0;
        > img {
          position: absolute;
          top: -35px;
          left: 56px;
          width: 154px;
          height: 111px;
        }
        > h3 {
          font-size: 20px;
          line-height: 28px;
          margin-bottom: 0;
        }
        > h2 {
          font-size: 30px;
          line-height: 40px;
          margin-bottom: 10px;
        }
        > p {
          font-size: 16px;
          line-height: 26px;
          margin-bottom: 30px;
        }
        > .buttons {
          > a {
            width: 220px;
            height: 50px;
            border-radius: 12px;
            font-size: 14px;
            line-height: 18px;
          }
        }
      }
    }
  }
  @media screen and (max-width: 767px) {
    .learn-block {
      background-size: 100% 540px;
      padding-top: 0;
      min-height: 313px;
      margin: 45px 15px 0 15px;

      > .container {
        background-image: linear-gradient(180deg, rgba(201, 216, 255, 0.1) 0%, rgba(201, 216, 255, 0) 100%);
        position: relative;
        min-height: 313px;
        padding-top: 56px;
        border-radius: 20px 20px 0 0;
        > img {
          position: absolute;
          top: -35px;
          left: calc((100% / 2) - 55px);
          width: 111px;
          height: 80px;
        }
        > h3 {
          font-size: 14px;
          line-height: 20px;
          margin-bottom: 0;
        }
        > h2 {
          font-size: 20px;
          line-height: 26px;
          margin-bottom: 10px;
        }
        > p {
          font-size: 13px;
          line-height: 22px;
          margin-bottom: 21px;
          padding: 0 15px;
          > br {
            display: none;
          }
        }
        > .buttons {
          > a {
            width: 100%;
            height: 40px;
            border-radius: 12px;
            font-size: 14px;
            line-height: 18px;
          }
        }
      }
    }
  }
</style>
